import PlaytimeForm from '@/components/common/media-menu/schedule-playtime-menu-item/playtime-form/playtime-form-tmpl'

export default {
  name: 'userDbRowMenu',
  inject: [
    '$utils'
  ],
  components: { PlaytimeForm },
  props: {
    userDbRowProp: {
      default () { return null }
    },
    selectedUserDbDetailsProp: {
      default () { return null }
    },
    defaultNumberOfColumnsProp: {
      default () { return 0 }
    },
    selectedCellProp: {
      default () { return { column: null, row: null } }
    }
  },
  watch: {
    selectedUserDbDetailsProp (newVal) {
      this.selectedUserDbDetails = newVal
      this.setDefaultData(this.selectedUserDbDetails)
    },
    userDbRowProp (newVal) {
      this.userDbRow = newVal
    },
    defaultNumberOfColumnsProp (newVal) {
      this.menuData.numOfColumns = newVal
    },
    selectedCellProp (newVal, prevVal) {
      this.selectedCell = newVal
      this.handleSelectedCell(this.selectedCell)
    }
  },
  mixins: [],
  data () {
    return {
      error: '',
      userDbRow: this.userDbRowProp,
      numberOfColumn: -1,
      numberOfColumnOptions: [1, 2, 3, 4, 5],
      selectedUserDbDetails: this.selectedUserDbDetailsProp,
      menuData: {
        numOfColumns: this.defaultNumberOfColumnsProp
      },
      menuItemsId: { column: 'column', schedule: 'schedule' },
      menuItems: [{
        id: 'column',
        name: 'COLUMNS',
        value: null,
        type: 'column',
        editable: true,
        show: false
      },
      {
        id: 'schedule',
        name: 'PLAYTIME',
        value: null,
        type: 'column',
        editable: true,
        show: false
      }],
      playtimeFormData: {},
      selectedCell: null,
      showSubmitButton: true
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('user-db-menu-change', { action, payload: { data } })
      }
    },
    setDefaultData (selectedUserDbDetails) {
      this.resetMenuItemsVisibility({ target: [this.menuItemsId.column] })

      // Show Column menu item
      let menuItems = this.$utils.clone(this.menuItems)
      menuItems = menuItems.map((item) => {
        if (item.id === this.menuItemsId.column && !selectedUserDbDetails._edit.hideColumnsSettings) item.show = true
        return item
      })
      this.menuItems = menuItems
    },
    handleMenuItemChange (colValue) {
      this.menuData.numOfColumns = colValue
      const numberOfColumns = this.menuData.numOfColumns
      this.emitEvent('NUMBER_OF_COLUMN_CHANGE', numberOfColumns)
    },
    handleSubmitButtonClick () {
      this.emitEvent('SUBMIT_BUTTON_CLICKED')
    },
    handlePlaytimeFormChange (event) {
      if (event.action === 'PLAYTIME_FORM_UPDATED') {
        const playtimeData = event.payload.data.playtimeData
        playtimeData.uid = playtimeData.uid ? playtimeData.uid : this.$utils.generateUniqueID()

        const selectedUserDbDetails = this.$utils.clone(this.selectedUserDbDetails)
        const selectedCell = this.$utils.clone(this.selectedCell)
        selectedCell.column.value = playtimeData

        selectedUserDbDetails._edit.data[selectedCell.row.rowIndex][selectedCell.column.columnName] = playtimeData
        this.selectedUserDbDetails = selectedUserDbDetails

        this.emitEvent('PLAYTIME_FORM_UPDATED', {
          playtimeData,
          updatedSelectedCell: selectedCell,
          updatedUserDbDetails: this.selectedUserDbDetails
        })
      }
    },
    handleSelectedCell (selectedCellSrc) {
      this.showSubmitButton = true
      this.playtimeFormData = {}
      this.resetMenuItemsVisibility({ target: [this.menuItemsId.schedule] })
      const selectedCell = this.$utils.clone(selectedCellSrc)
      let showPlaytimeMenuItem = false

      // Set Playtime
      if (selectedCell.column && (selectedCell.column.type && selectedCell.column.type === 'schedule')) {
        const columnValue = selectedCell.column.value

        const playtimeSourceData = {
          daily: false,
          duration: columnValue.duration ? columnValue.duration : null,
          startDate: columnValue.startDate ? columnValue.startDate : null,
          endDate: columnValue.endDate ? columnValue.endDate : null,
          startTime: columnValue.startTime ? columnValue.startTime : null,
          priority: columnValue.priority ? columnValue.priority : false,
          repeatDays: columnValue.repeatDays ? columnValue.repeatDays : [],
          uid: columnValue.uid ? columnValue.uid : this.$utils.generateUniqueID()
        }

        this.playtimeFormData = playtimeSourceData
        showPlaytimeMenuItem = true
        this.showSubmitButton = false
      }

      // Show Schedule playtime menu item
      let menuItems = this.$utils.clone(this.menuItems)
      menuItems = menuItems.map((item) => {
        if (item.id === this.menuItemsId.schedule) item.show = showPlaytimeMenuItem
        return item
      })
      this.menuItems = menuItems
    },
    resetMenuItemsVisibility (params) {
      let menuItems = this.$utils.clone(this.menuItems)
      menuItems = menuItems.map((item) => {
        if (params.target && params.target.indexOf(item.id) >= 0) {
          item.show = false
        } else if (params.all) {
          item.show = false
        }
        return item
      })
      this.menuItems = menuItems
    }
  },
  mounted () {
    this.setDefaultData(this.selectedUserDbDetailsProp)
  }
}
